import {useMutation} from "@apollo/client";
import pluralize from "pluralize";

import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {GQL_CHECKS_QUERY2, GQL_UPDATE_LOCATIONS_STATE} from "@/lib/queries/checks.ts";
import {GraphQLResponse, ResponseStatus} from "@/lib/types/common.ts";
import {BulkSetLocationsForm} from "@/pages/checks/list/actions/bulkSetLocations/BulkSetLocationsForm.tsx";

export interface EditCheckLocationsFormValues {
  monitoring_groups: number[];
}

export interface BulkSetMaintenanceModalProps {
  selectedItemsIds: number[];
  show: boolean;
  setShow: (show: boolean) => void;
  onSuccess: () => void;
}

export const BulkSetLocationsModal = ({selectedItemsIds, show, setShow, onSuccess}: BulkSetMaintenanceModalProps) => {
  const [updateChecksLocation, {data, loading}] = useMutation<GraphQLResponse<null>>(GQL_UPDATE_LOCATIONS_STATE, {
    refetchQueries: [GQL_CHECKS_QUERY2],
  });

  const handleSubmit = async (data: EditCheckLocationsFormValues) => {
    const response = await updateChecksLocation({
      variables: {
        ids: selectedItemsIds,
        monitoring_groups: data.monitoring_groups,
      },
    });
    if (response.data?.response.status === ResponseStatus.SUCCESS) {
      setShow(false);
      onSuccess();
    }
  };

  const formId = "BulkSetLocationsForm";
  return (
    <FormModal
      disabled={loading}
      formId={formId}
      onCancel={() => setShow(false)}
      show={show}
      title={`Set Locations on ${pluralize("Check", selectedItemsIds.length, true)}`}
      hasRequiredFields
    >
      <BulkSetLocationsForm
        formId={formId}
        onSubmit={handleSubmit}
        serverErrors={data?.response?.status === ResponseStatus.ERROR ? data.response.message : undefined}
        onError={console.log}
      />
    </FormModal>
  );
};
